import { Box, styled, Tab, Tabs, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { setAreaLevel, getAreaLevel } from '../../reducer/areaLevelSlice';
import { useEffect, useState } from 'react';
import { getProfile } from '../../reducer/profileSlice';

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        minHeight: '40px',
        height: '40px',
        color: 'black',
        '&.Mui-selected': {
            color: '#fff',
            zIndex: 2
        },
        '&.Mui-focusVisible': {
            backgroundColor: 'rgba(100, 95, 228, 0.32)',
        },
    }),
);

function AreaLevelSetting() {
    const areaLevel = useSelector(getAreaLevel);
    const profile = useSelector(getProfile);
    const dispatch = useDispatch();
    const [areaLevelSelected, setAreaLevelSeleceted] = useState(areaLevel);

    useEffect(() => {
        if (profile) {
            // console.log(profile);
            const org_level = parseInt(profile.org_level);
            let areaLevel = "province"
            if (org_level === 4) {
                areaLevel = "amphur";
            } else if (org_level === 5) {
                areaLevel = "tambon";
            }
            setAreaLevelSeleceted(areaLevel)
            dispatch(setAreaLevel(areaLevel));
        }
    }, [profile])

    const handleChange = (event, newValue) => {
        setAreaLevelSeleceted(newValue);
        dispatch(setAreaLevel(newValue));
    };
    return (
        <>

            <Box sx={{
                textAlign: 'left'
            }}>
                <Typography 
                    variant="h6"
                    component="h6" 
                    sx={{
                        color: 'black',
                        fontSize: '1rem',
                        fontWeight: '400',
                        mt: 2
                }}>
                    ระดับแผนที่การแสดงผล
                </Typography>
                <Tabs 
                    value={areaLevelSelected}
                    variant="fullWidth"
                    onChange={handleChange}
                    sx={{
                        marginTop: '8px',
                        minHeight: '40px',
                        height: '40px',
                        backgroundColor: 'rgba(0, 0, 0, 0.23)',
                        // boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
                        borderRadius: '4px',
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'rgb(62, 152, 211)',
                            zIndex: 1,
                            height: '100%'
                        }
                    }}
                >
                    <StyledTab label="จังหวัด" value="province" />
                    <StyledTab label="อำเภอ" value="amphur" />
                    <StyledTab label="ตำบล" value="tambon" />
                </Tabs>
            </Box>
        </>
    )
}

export default AreaLevelSetting;